/**
 * Safely extracts a human-readable error string from any API error.
 * Handles FastAPI 422 validation errors (detail as an array of objects)
 * as well as standard message/detail strings.
 */
export const extractApiError = (err, fallback = 'An unexpected error occurred.') => {
    const data = err?.response?.data;
    if (!data) return err?.message || fallback;

    const detail = data.detail;

    // FastAPI 422: detail is an array of validation error objects [{type, loc, msg, input}]
    if (Array.isArray(detail)) {
        return detail.map((d) => {
            const field = Array.isArray(d.loc) ? d.loc.filter(x => x !== 'body').join('.') : '';
            return field ? `${field}: ${d.msg}` : d.msg;
        }).join('; ') || fallback;
    }

    // Standard string detail
    if (typeof detail === 'string') return detail;

    // Standard message field
    if (typeof data.message === 'string') return data.message;

    return fallback;
};
